import { render, staticRenderFns } from "./ManyPic.vue?vue&type=template&id=2d639ff6&scoped=true&"
import script from "./ManyPic.vue?vue&type=script&lang=ts&"
export * from "./ManyPic.vue?vue&type=script&lang=ts&"
import style0 from "./ManyPic.vue?vue&type=style&index=0&id=2d639ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d639ff6",
  null
  
)

export default component.exports